import {Controller} from "@hotwired/stimulus";
import {putJson} from "~/lib/request";

// "Add all to cart" button of the watch list overview (watch_lists/current).
// Moves every bookable course of the watch list into the cart in one request
// and reloads: the page is rendered server-side (rows, header badges, and the
// courses that stayed behind because they are not bookable), so re-rendering it
// by hand would mean duplicating all of that in JS.
export default class extends Controller {
    static values = {url: String};

    addAll(event) {
        event?.preventDefault();
        if (this.pending || !this.urlValue) return;

        this.pending = true;
        this.element.classList.add("disabled");
        putJson(this.urlValue, {})
            .then(() => window.location.reload())
            .catch((error) => {
                console.error("adding the watch list to the cart failed", error);
                // hardcoded German like the other frontend controllers - the Vite
                // bundle has no gettext (see 15087-redesign-improvements.md, 4.4)
                window.alert("Das hat leider nicht geklappt. Bitte laden Sie die Seite neu und versuchen Sie es erneut.");
                this.pending = false;
                this.element.classList.remove("disabled");
            });
    }
}
